import { QrCodeScanner } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SecurityScan = () => {
  const [visitorId, setVisitorId] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const handleScan = async () => {
    if (!visitorId.trim()) return;

    setLoading(true);

    try {
      const res = await axios.post(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/api/form/scan?visitorId=${visitorId.trim()}`
      );

      toast.success(` scanned successfully! `, { position: "top-right" });
      fetchLast5Records();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Server error", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
      setVisitorId("");
    }
  };

  const fetchLast5Records = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/form/last5ScanRecords`
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching scanning records", error.message);
    }
  };
  useEffect(() => {
    fetchLast5Records();
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleScan();
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        bgcolor: "#f4f6f8",
        px: 2,
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Security QR Scan
      </Typography>

      <TextField
        label="Scan QR / Enter Visitor ID"
        variant="outlined"
        value={visitorId}
        onChange={(e) => setVisitorId(e.target.value.toUpperCase())}
        placeholder="Scan Badge"
        onKeyDown={handleKeyPress}
        sx={{ width: 400, mb: 2 }}
        required
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <QrCodeScanner />
            </InputAdornment>
          ),
        }}
      />
      {loading && <CircularProgress sx={{ mt: 2 }} />}
      <TableContainer
        component={Paper}
        style={{ marginTop: "50px", height: "50vh" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {[
                "Visitor ID",
                "Name",
                "Designation",
                "Scan Date",
                "Scan Time",
              ].map((heading) => (
                <TableCell
                  key={heading}
                  align="center"
                  sx={{ fontWeight: "bold" }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((user) => (
              <TableRow key={user._id}>
                <TableCell align="center">{user.visitorId}</TableCell>
                <TableCell align="center">
                  {`${user.firstName} ${user.lastName}`.trim()}
                </TableCell>
                <TableCell align="center">
                  {user.designation.toUpperCase()}
                </TableCell>
                <TableCell align="center">
                  {new Date(user.latestScan).toLocaleDateString()}
                </TableCell>
                <TableCell align="center">
                  {new Date(user.latestScan).toLocaleTimeString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ToastContainer position="top-center" autoClose={3000} />
    </Box>
  );
};

export default SecurityScan;
